import { SeoPage } from 'libs/shared-lib/interfaces';
export const VEHICLE_NOT_AVAILABLE_SEO_DE: SeoPage = {
    title: 'Fahrzeug nicht gefunden',
    description: 'Das Fahrzeug konnte nicht gefunden werden',
    image: '',
    twitter: {
        card: 'summary',
        title: 'Fahrzeug nicht gefunden',
        description: 'Das Fahrzeug konnte nicht gefunden werden',
    },
    og: {
        title: 'Fahrzeug nicht gefunden',
        description: 'Das Fahrzeug konnte nicht gefunden werden',
    },
    robots: {
        noIndex: true,
        noFollow: true,
    },
};
